var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cp-header',{attrs:{"partner":_vm.hasPartnerA2G}}),_c(_vm.component,{tag:"component"}),(!_vm.hasPartnerA2G)?_c('cb-footer',{attrs:{"product":"trip","hideLinks":_vm.showLivelo ? [] : ['pontos-livelo'],"INSTITUCIONAL_URL":"https://www.ciclic.com.br"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }